function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * `walkDOMTree` is not exported as it provides the `isRecursive` argument for providing the context of recursion
 * @param isRecursive - indicates if the fn was called recursively, used when cloning the root node
 * @param domNode - a root node that should contain children
 * @param handleNodeFn - a function to mutate the dom tree
 */
function walkDOMTree(isRecursive, domNode, handleNodeFn) {
  /**
   * check if the `currentNode` is the root node
   * if it is the root node we clone it
   * to prevent side effect mutations to it's reference
   */
  var currentNode = domNode;

  if (!isRecursive) {
    currentNode = domNode.cloneNode(true);
  }

  if (!currentNode || !currentNode.hasChildNodes()) {
    return null;
  }
  /**
   * `handleNodeFn` can mutate it's reference to the `rootNode`
   * we risk iteration side effects of modifying the array like structure
   * for ex; iterating over `childNodes` and removing a child will change the length
   * and result in pointing to `undefined`
   *
   * to mitigate that we place the nodes into it's own array, and mutate
   * the dom tree directly, without interfering with the iterable variables
   */


  var children = Array.prototype.slice.call(currentNode.childNodes);

  var _iterator = _createForOfIteratorHelper(children),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _node = _step.value;
      handleNodeFn(_node);

      if (_node.hasChildNodes()) {
        walkDOMTree(true, _node, handleNodeFn);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return currentNode;
}

/**
 * `walk` will create a new DOM tree and mutate it in isolation in order to prevent side effects
 *
 * @param domNode - the root dom node to begin walking from
 * @param handleNodeFn - a function to mutate the dom tree
 */
var walk = function walk(domNode, handleNodeFn) {
  // prevent `isRecursive` from being exposed
  return walkDOMTree(false, domNode, handleNodeFn);
};

export default walk;